import React, { useState } from "react";
import { CmpTemplates } from "../../../components/template/CmpTemplates";
import AgreementPageContent from "../../../components/organisms/AgreementPageContent";
import { userSignState } from "../../../states/user-sign-up";
import { useRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";

const CmpAgreementPage = () => {
  const navigate = useNavigate();
  const [userSignUpData, setUserSignUpData] = useRecoilState(userSignState);

  // 약관 동의 체크 State
  const [isCheck, setIsCheck] = useState<boolean>(
    userSignUpData.userInfo.userAssignment ? true : false
  );

  const onPageBackHanlder = () => {
    navigate(-1);
  };

  const onPageNextHanlder = () => {
    setUserSignUpData((prev: any) => ({
      ...prev,
      userInfo: { ...prev.userInfo, userAssignment: isCheck },
    }));
    navigate("/sign-up");
  };

  return (
    <CmpTemplates pageTitle="회원가입">
      <AgreementPageContent
        onPageBackHanlder={onPageBackHanlder}
        onPageNextHanlder={onPageNextHanlder}
        setIsCheck={setIsCheck}
        isCheck={isCheck}
      />
    </CmpTemplates>
  );
};

export default CmpAgreementPage;
